import React from 'react';
import { useAuth } from "../../contexts/AuthContext";
import EchangesList from '../EchangesList/EchangesList';
import TableauDeBord from '../TableauDeBord/TableauDeBord';
import SectionPliable from '../SectionPliable/SectionPliable';
import Button from '../Button/Button';
import { ReactComponent as PdfIcon } from '../../assets/icons/pdf.svg';
import { exportHistoriquePdf } from '../../utils/exportHistoriquePdf';

interface OperationSuiviMarcheProps {
  operation: any;
}

// Feuille BC-acheteur pure : historique + memos d'une operation. Aucune branche MS/prestataire.
const OperationSuiviMarche: React.FC<OperationSuiviMarcheProps> = ({ operation }) => {
  const { user } = useAuth();

  const currentUser = {
    id: user?.id || null,
    name: user?.name || 'Utilisateur',
    role: user?.role || 'user'
  };

  const formatDate = (dateString: string) => {
    if (!dateString) return '-';
    const date = new Date(dateString);
    return date.toLocaleDateString('fr-FR', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  const historiqueColumns = [
    {
      field: 'date',
      header: 'Date',
      renderCell: (_: any, row: any) => (
        <div className="date-cell">{formatDate(row.created_at)}</div>
      )
    },
    {
      field: 'operateur',
      header: 'Opérateur',
      renderCell: (_: any, row: any) => (
        <div className="operateur-cell">{row.operateur || '-'}</div>
      )
    },
    {
      field: 'action',
      header: 'Action',
      renderCell: (_: any, row: any) => (
        <div className="action-cell">{row.prefix || '-'}</div>
      )
    },
    {
      field: 'description',
      header: 'Description',
      renderCell: (_: any, row: any) => (
        <div className="description-cell">{row.label || '-'}</div>
      )
    }
  ];

  return (
    <div className="tab-suivi-marche">
      <SectionPliable title="Historique">
        {operation.historique && operation.historique.length > 0 ? (
          <TableauDeBord
            data={operation.historique}
            columns={historiqueColumns}
            onSearch={() => { }}
            showActionsColumn={false}
            isSelectable={false}
            selectedItems={[]}
            onSelectionChange={() => { }}
            footerLeft={
              <Button
                value="Télécharger le PDF"
                variant="secondary"
                icon={<PdfIcon />}
                onClick={() => exportHistoriquePdf(operation.historique, 'Historique', currentUser.name)}
              />
            }
          />
        ) : (
          <div className="empty-state">Aucun historique disponible</div>
        )}
      </SectionPliable>
      <SectionPliable title="Mémo interne">
        <EchangesList
          typeElement="operation"
          idElement={operation.id}
          currentUser={currentUser}
          showCommentaireForm={true}
        />
      </SectionPliable>
    </div>
  );
};

export default OperationSuiviMarche;
